import React, { useState, useEffect } from 'react';
import { Sword, Shield, Brain, Trophy, Sparkles, Gift, Zap, Target, Calendar, TrendingUp, Award, Share2, Crown, Lock, Check } from 'lucide-react';

// ========================================
// 100 MAIN QUESTS - 賢明な投資家として設計
// ========================================
const MAIN_QUESTS = [
  // Phase 1: 基礎構築 (Level 1-25)
  { id: 1, level: 1, title: "投資家への第一歩", description: "自分の財務状況を正確に把握する", conditions: ["銀行口座の残高を確認した", "クレジットカードの残高を確認した", "現金を数えた"], gold: 50, exp: 100, isBoss: false },
  { id: 2, level: 1, title: "負債の棚卸し", description: "すべての借入を明確にする", conditions: ["住宅ローン残高を確認した", "自動車ローン残高を確認した", "その他の負債をリスト化した"], gold: 50, exp: 100, isBoss: false },
  { id: 3, level: 2, title: "収支の可視化", description: "月々の収入と支出を記録する", conditions: ["先月の収入を記録した", "先月の固定費を記録した", "先月の変動費を記録した"], gold: 60, exp: 120, isBoss: false },
  { id: 4, level: 3, title: "【ボス】財務状況の完全把握", description: "お金の流れを完全に理解する", conditions: ["純資産を計算した", "月間収支を把握した", "年間支出を予測した", "財務状況レポートを作成した"], gold: 150, exp: 300, isBoss: true },
  
  { id: 5, level: 4, title: "緊急資金の重要性", description: "緊急時の備えについて学ぶ", conditions: ["生活費3ヶ月分を計算した", "緊急資金の目標額を設定した", "緊急資金専用口座を開設した"], gold: 70, exp: 140, isBoss: false },
  { id: 6, level: 5, title: "投資の基礎知識", description: "株式と債券の違いを理解する", conditions: ["株式の基本を学習した", "債券の基本を学習した", "リスクとリターンの関係を理解した"], gold: 80, exp: 160, isBoss: false },
  { id: 7, level: 6, title: "証券口座の開設", description: "投資を始める準備をする", conditions: ["証券会社を選択した", "口座開設書類を提出した", "口座開設が完了した"], gold: 90, exp: 180, isBoss: false },
  { id: 8, level: 7, title: "投資方針の策定", description: "自分の投資スタイルを決める", conditions: ["リスク許容度を評価した", "投資期間を設定した", "目標リターンを定めた"], gold: 100, exp: 200, isBoss: false },
  { id: 9, level: 8, title: "初めての投資", description: "最初の一歩を踏み出す", conditions: ["投資信託またはETFを選んだ", "最初の購入を実行した", "購入記録を保存した"], gold: 110, exp: 220, isBoss: false },
  { id: 10, level: 10, title: "【ボス】初心者投資家の誕生", description: "投資家としての基礎を固める", conditions: ["毎月の積立額を決定した", "自動積立を設定した", "3ヶ月連続で積立を実行した", "投資日記を開始した", "家族に投資方針を説明した"], gold: 250, exp: 500, isBoss: true },
  
  { id: 11, level: 11, title: "分散投資の理解", description: "リスク分散の重要性を学ぶ", conditions: ["アセットアロケーションを学習した", "地域分散の重要性を理解した", "自分のポートフォリオを設計した"], gold: 120, exp: 240, isBoss: false },
  { id: 12, level: 12, title: "つみたてNISAの活用", description: "税制優遇制度を理解する", conditions: ["つみたてNISAの仕組みを学習した", "対象商品を調査した", "つみたてNISA口座を開設した"], gold: 130, exp: 260, isBoss: false },
  { id: 13, level: 13, title: "iDeCoの検討", description: "老後資金作りの選択肢を知る", conditions: ["iDeCoの仕組みを学習した", "自分の拠出可能額を確認した", "メリット・デメリットを理解した"], gold: 140, exp: 280, isBoss: false },
  { id: 14, level: 14, title: "インデックス投資の深掘り", description: "市場平均を目指す投資法を学ぶ", conditions: ["パッシブ運用を理解した", "主要インデックスを調査した", "経費率の重要性を学んだ"], gold: 150, exp: 300, isBoss: false },
  { id: 15, level: 15, title: "【ボス】税制優遇の達人", description: "制度を使いこなす", conditions: ["NISA口座で投資を開始した", "iDeCoの設定を完了した", "6ヶ月間の投資実績を記録した", "税制メリットを計算した", "年間投資計画を立てた"], gold: 350, exp: 700, isBoss: true },
  
  { id: 16, level: 16, title: "ドルコスト平均法", description: "時間分散の効果を理解する", conditions: ["ドルコスト平均法の仕組みを学習した", "一括投資との違いを理解した", "実践プランを立てた"], gold: 160, exp: 320, isBoss: false },
  { id: 17, level: 17, title: "リバランスの実践", description: "ポートフォリオのメンテナンスを学ぶ", conditions: ["リバランスの目的を理解した", "現在の資産配分を確認した", "目標配分との差を計算した"], gold: 170, exp: 340, isBoss: false },
  { id: 18, level: 18, title: "配当再投資", description: "複利の力を活用する", conditions: ["配当再投資の仕組みを学習した", "再投資設定を確認した", "長期効果をシミュレーションした"], gold: 180, exp: 360, isBoss: false },
  { id: 19, level: 19, title: "為替リスクの理解", description: "外国株投資の注意点を学ぶ", conditions: ["為替リスクの影響を学習した", "ヘッジの概念を理解した", "自分の方針を決定した"], gold: 190, exp: 380, isBoss: false },
  { id: 20, level: 20, title: "【ボス】実践投資家への進化", description: "投資の実践力を証明する", conditions: ["1年間の投資記録をまとめた", "ポートフォリオを分析した", "初回リバランスを実行した", "投資方針書を更新した", "次の1年の目標を設定した"], gold: 450, exp: 900, isBoss: true },
  
  { id: 21, level: 21, title: "投資信託の目論見書", description: "商品選びの基準を学ぶ", conditions: ["目論見書の読み方を学習した", "運用方針を確認した", "手数料体系を理解した"], gold: 200, exp: 400, isBoss: false },
  { id: 22, level: 22, title: "市場の変動への対応", description: "暴落時の心構えを持つ", conditions: ["歴史的な暴落を学習した", "長期投資の重要性を再確認した", "感情的な売買を避ける決意をした"], gold: 210, exp: 420, isBoss: false },
  { id: 23, level: 23, title: "債券の役割", description: "守りの資産を理解する", conditions: ["債券の基本を復習した", "株式との相関を学習した", "ポートフォリオでの役割を理解した"], gold: 220, exp: 440, isBoss: false },
  { id: 24, level: 24, title: "REIT入門", description: "不動産投資の選択肢を知る", conditions: ["REITの仕組みを学習した", "配当利回りの特徴を理解した", "投資対象として検討した"], gold: 230, exp: 460, isBoss: false },
  { id: 25, level: 25, title: "【ボス】知識の結晶化", description: "学んだことを体系化する", conditions: ["投資知識ノートを作成した", "自分のQ&Aリストを作った", "18ヶ月の投資成果を分析した", "家族・友人に投資を説明できる", "次の2年の投資計画を立てた"], gold: 550, exp: 1100, isBoss: true },
  
  // Phase 2: 知識の拡充 (Level 26-50)
  { id: 26, level: 26, title: "コモディティ投資", description: "オルタナティブ資産を学ぶ", conditions: ["金・原油などの特性を学習した", "インフレヘッジを理解した", "ポートフォリオでの位置づけを考えた"], gold: 240, exp: 480, isBoss: false },
  { id: 27, level: 27, title: "新興国市場", description: "成長市場への投資を考える", conditions: ["新興国の定義を学習した", "リスクとリターンを理解した", "投資の可否を判断した"], gold: 250, exp: 500, isBoss: false },
  { id: 28, level: 28, title: "ESG投資", description: "持続可能な投資を学ぶ", conditions: ["ESGの概念を学習した", "ESG投資信託を調査した", "自分の価値観と照らし合わせた"], gold: 260, exp: 520, isBoss: false },
  { id: 29, level: 29, title: "セクター分析", description: "業種別の特性を理解する", conditions: ["主要11セクターを学習した", "景気循環との関係を理解した", "ポートフォリオへの応用を考えた"], gold: 270, exp: 540, isBoss: false },
  { id: 30, level: 30, title: "【ボス】中級投資家の証明", description: "投資戦略を確立する", conditions: ["2年間の投資成果を総括した", "複数資産クラスに投資した", "リバランスを3回実施した", "投資方針を全面改訂した", "次の3年の戦略を策定した"], gold: 650, exp: 1300, isBoss: true },
  
  { id: 31, level: 31, title: "スマートベータ", description: "ファクター投資を学ぶ", conditions: ["ファクターの概念を学習した", "バリュー・モメンタム等を理解した", "適用可能性を検討した"], gold: 280, exp: 560, isBoss: false },
  { id: 32, level: 32, title: "税金の最適化", description: "税務面での効率を高める", conditions: ["譲渡益課税を理解した", "損益通算の仕組みを学習した", "確定申告の準備をした"], gold: 290, exp: 580, isBoss: false },
  { id: 33, level: 33, title: "年金制度の理解", description: "公的年金を把握する", conditions: ["ねんきん定期便を確認した", "受給見込み額を把握した", "不足分を試算した"], gold: 300, exp: 600, isBoss: false },
  { id: 34, level: 34, title: "アセットロケーション", description: "口座の使い分けを最適化する", conditions: ["課税口座・非課税口座の違いを整理した", "商品配置を最適化した", "税効率を高めた"], gold: 310, exp: 620, isBoss: false },
  { id: 35, level: 35, title: "【ボス】戦略の洗練", description: "投資技術を磨く", conditions: ["税務戦略を確立した", "アセットロケーションを最適化した", "3年間の実績を分析した", "投資哲学を明文化した", "今後5年の計画を立てた"], gold: 750, exp: 1500, isBoss: true },
  
  { id: 36, level: 36, title: "レバレッジ投資の理解", description: "借入投資のリスクを知る", conditions: ["レバレッジの仕組みを学習した", "リスクを理解した", "自分には不要と判断した"], gold: 320, exp: 640, isBoss: false },
  { id: 37, level: 37, title: "オプション取引の基礎", description: "デリバティブを学ぶ", conditions: ["コール・プットを学習した", "リスク構造を理解した", "実践の可否を判断した"], gold: 330, exp: 660, isBoss: false },
  { id: 38, level: 38, title: "ファイナンシャルプラン", description: "人生設計と投資を結びつける", conditions: ["ライフイベントをリストアップした", "必要資金を見積もった", "投資計画に反映させた"], gold: 340, exp: 680, isBoss: false },
  { id: 39, level: 39, title: "保険の見直し", description: "リスク管理を最適化する", conditions: ["現在の保険を棚卸しした", "必要保障額を計算した", "過不足を是正した"], gold: 350, exp: 700, isBoss: false },
  { id: 40, level: 40, title: "【ボス】上級者への階段", description: "高度な知識を獲得する", conditions: ["4年間の投資履歴を総括した", "全資産クラスを理解した", "リスク管理を完璧にした", "ライフプランを完成させた", "残り30年の計画を立てた"], gold: 850, exp: 1700, isBoss: true },
  
  { id: 41, level: 41, title: "教育資金の準備", description: "子供の未来に投資する", conditions: ["教育費を試算した", "準備方法を検討した", "具体的な行動を開始した"], gold: 360, exp: 720, isBoss: false },
  { id: 42, level: 42, title: "住宅購入と投資", description: "大きな買い物と投資のバランス", conditions: ["住宅購入の影響を試算した", "頭金と投資の配分を考えた", "最適なバランスを見つけた"], gold: 370, exp: 740, isBoss: false },
  { id: 43, level: 43, title: "相続の基礎", description: "資産承継を考え始める", conditions: ["相続の基本を学習した", "相続税の仕組みを理解した", "対策の必要性を判断した"], gold: 380, exp: 760, isBoss: false },
  { id: 44, level: 44, title: "グローバル投資", description: "世界に目を向ける", conditions: ["先進国・新興国の配分を見直した", "地域別のリスク・リターンを分析した", "最適な配分を決定した"], gold: 390, exp: 780, isBoss: false },
  { id: 45, level: 45, title: "【ボス】ベテラン投資家の風格", description: "経験値を積み上げる", conditions: ["5年間の投資成果を総括した", "複利の威力を実感した", "後進にアドバイスできる", "投資コミュニティに貢献した", "次の10年の展望を描いた"], gold: 950, exp: 1900, isBoss: true },
  
  { id: 46, level: 46, title: "市場サイクルの理解", description: "景気循環と投資の関係", conditions: ["景気循環の4段階を学習した", "各段階での戦略を理解した", "現在の局面を判断した"], gold: 400, exp: 800, isBoss: false },
  { id: 47, level: 47, title: "バリュエーション分析", description: "割高・割安を見極める", conditions: ["PER・PBRを学習した", "市場全体の評価を確認した", "投資判断に活用した"], gold: 410, exp: 820, isBoss: false },
  { id: 48, level: 48, title: "行動経済学", description: "投資心理を理解する", conditions: ["認知バイアスを学習した", "損失回避性を理解した", "感情的判断を避ける工夫をした"], gold: 420, exp: 840, isBoss: false },
  { id: 49, level: 49, title: "リスク管理の深化", description: "下落リスクへの備え", conditions: ["VaRの概念を学習した", "最大ドローダウンを確認した", "リスク許容度を再評価した"], gold: 430, exp: 860, isBoss: false },
  { id: 50, level: 50, title: "【ボス】マスター投資家への到達", description: "中級の集大成", conditions: ["7年間の投資を完全総括した", "すべての基本を習得した", "安定したリターンを実現した", "投資哲学を確立した", "マスターの称号を得た"], gold: 1050, exp: 2100, isBoss: true },
  
  // Phase 3: 高度な技術 (Level 51-75)
  { id: 51, level: 51, title: "パフォーマンス測定", description: "成果を正しく評価する", conditions: ["ベンチマークを設定した", "トータルリターンを計算した", "時間加重収益率を理解した"], gold: 440, exp: 880, isBoss: false },
  { id: 52, level: 52, title: "マクロ経済指標", description: "経済の大きな流れを読む", conditions: ["GDP・失業率などの指標を学習した", "金融政策の影響を理解した", "投資への応用を考えた"], gold: 450, exp: 900, isBoss: false },
  { id: 53, level: 53, title: "企業分析の基礎", description: "個別株への理解を深める", conditions: ["財務諸表の基本を学習した", "ROE・ROAを理解した", "企業評価の視点を得た"], gold: 460, exp: 920, isBoss: false },
  { id: 54, level: 54, title: "配当成長投資", description: "インカムゲインに注目する", conditions: ["配当利回りと成長率を学習した", "配当貴族を調査した", "戦略としての有効性を評価した"], gold: 470, exp: 940, isBoss: false },
  { id: 55, level: 55, title: "【ボス】達人の境地", description: "投資の真髄を掴む", conditions: ["10年間の投資成果を総括した", "市場を深く理解した", "独自の投資スタイルを確立した", "メンターとして活動開始した", "次の段階への準備完了"], gold: 1150, exp: 2300, isBoss: true },
  
  { id: 56, level: 56, title: "為替ヘッジ戦略", description: "通貨リスクの管理法", conditions: ["ヘッジコストを理解した", "ヘッジあり・なしを比較した", "自分の方針を確立した"], gold: 480, exp: 960, isBoss: false },
  { id: 57, level: 57, title: "モダンポートフォリオ理論", description: "効率的フロンティアを学ぶ", conditions: ["MPTの基本を学習した", "効率的フロンティアを理解した", "自分のポートフォリオを評価した"], gold: 490, exp: 980, isBoss: false },
  { id: 58, level: 58, title: "ファクター投資の実践", description: "スマートベータを活用する", conditions: ["複数ファクターを組み合わせた", "ファクター投資商品を選定した", "ポートフォリオに組み入れた"], gold: 500, exp: 1000, isBoss: false },
  { id: 59, level: 59, title: "オルタナティブ投資", description: "伝統的資産以外への投資", conditions: ["ヘッジファンド・PEを学習した", "流動性リスクを理解した", "投資の可否を判断した"], gold: 510, exp: 1020, isBoss: false },
  { id: 60, level: 60, title: "【ボス】高度技術の習得", description: "専門家レベルの知識", conditions: ["12年間の投資履歴を分析した", "高度な理論を理解した", "実践で成果を上げた", "投資セミナーで講師を務めた", "専門家として認められた"], gold: 1250, exp: 2500, isBoss: true },
  
  { id: 61, level: 61, title: "暗号資産の理解", description: "新しい資産クラスを学ぶ", conditions: ["ブロックチェーンを学習した", "価格変動性を理解した", "ポートフォリオでの位置づけを決めた"], gold: 520, exp: 1040, isBoss: false },
  { id: 62, level: 62, title: "サステナブル投資", description: "ESG投資を深掘りする", conditions: ["ESGスコアを学習した", "インパクト投資を理解した", "実践方法を確立した"], gold: 530, exp: 1060, isBoss: false },
  { id: 63, level: 63, title: "テーマ型投資", description: "未来のトレンドに投資する", conditions: ["メガトレンドを学習した", "テーマ型ETFを調査した", "投資の可否を判断した"], gold: 540, exp: 1080, isBoss: false },
  { id: 64, level: 64, title: "タクティカルアセットアロケーション", description: "機動的な資産配分", conditions: ["TAAAの概念を学習した", "タイミング投資のリスクを理解した", "自分の方針を確立した"], gold: 550, exp: 1100, isBoss: false },
  { id: 65, level: 65, title: "【ボス】賢者の称号", description: "知恵の結晶", conditions: ["15年間の投資人生を総括した", "あらゆる手法を理解した", "最適な戦略を実行した", "投資哲学書を執筆した", "賢者として尊敬された"], gold: 1350, exp: 2700, isBoss: true },
  
  { id: 66, level: 66, title: "グローバルマクロ戦略", description: "マクロ視点での投資", conditions: ["グローバルマクロを学習した", "通貨・金利戦略を理解した", "応用可能性を検討した"], gold: 560, exp: 1120, isBoss: false },
  { id: 67, level: 67, title: "リスクパリティ", description: "リスクベースの配分法", conditions: ["リスクパリティを学習した", "ボラティリティ調整を理解した", "実践方法を検討した"], gold: 570, exp: 1140, isBoss: false },
  { id: 68, level: 68, title: "行動ファイナンス実践", description: "心理的罠を完全回避する", conditions: ["主要なバイアス20個をリスト化した", "自分の投資判断を振り返った", "バイアス防止策を実装した"], gold: 580, exp: 1160, isBoss: false },
  { id: 69, level: 69, title: "高度な税務戦略", description: "税効率を極限まで高める", conditions: ["損益通算を最大活用した", "税繰り延べ戦略を実践した", "専門家に相談した"], gold: 590, exp: 1180, isBoss: false },
  { id: 70, level: 70, title: "【ボス】投資の覇者", description: "頂点への道", conditions: ["18年間の投資を完全総括した", "圧倒的な成果を上げた", "投資界で名を馳せた", "多くの人を導いた", "覇者の称号を得た"], gold: 1450, exp: 2900, isBoss: true },
  
  { id: 71, level: 71, title: "世代間資産移転", description: "資産を次世代につなぐ", conditions: ["贈与戦略を学習した", "教育資金贈与を活用した", "相続対策を開始した"], gold: 600, exp: 1200, isBoss: false },
  { id: 72, level: 72, title: "プライベートエクイティ", description: "未公開株投資を理解する", conditions: ["PEの仕組みを学習した", "流動性・リスクを理解した", "アクセス方法を調査した"], gold: 610, exp: 1220, isBoss: false },
  { id: 73, level: 73, title: "ベンチャー投資", description: "スタートアップへの投資", conditions: ["VC投資を学習した", "エンジェル投資を理解した", "リスク・リターンを評価した"], gold: 620, exp: 1240, isBoss: false },
  { id: 74, level: 74, title: "芸術品投資", description: "オルタナティブアセット", conditions: ["アート投資を学習した", "評価方法を理解した", "実物資産の特性を把握した"], gold: 630, exp: 1260, isBoss: false },
  { id: 75, level: 75, title: "【ボス】伝説の投資家", description: "伝説の始まり", conditions: ["20年間の投資成果を総括した", "資産形成目標を達成した", "投資界の伝説となった", "後世に名を残した", "伝説の称号を得た"], gold: 1550, exp: 3100, isBoss: true },
  
  // Phase 4: 究極の領域 (Level 76-100)
  { id: 76, level: 76, title: "構造化商品", description: "複雑な金融商品を理解する", conditions: ["仕組債を学習した", "リスク構造を理解した", "適用可能性を判断した"], gold: 640, exp: 1280, isBoss: false },
  { id: 77, level: 77, title: "ヘッジ戦略", description: "下落リスクをヘッジする", conditions: ["プット買いを学習した", "コストを計算した", "戦略の有効性を評価した"], gold: 650, exp: 1300, isBoss: false },
  { id: 78, level: 78, title: "グローバルタックスプラン", description: "国際税務を理解する", conditions: ["国際課税を学習した", "租税条約を理解した", "海外資産の申告を確認した"], gold: 660, exp: 1320, isBoss: false },
  { id: 79, level: 79, title: "クオンツ投資入門", description: "定量分析を学ぶ", conditions: ["統計的手法を学習した", "バックテストの概念を理解した", "データ分析ツールを試した"], gold: 670, exp: 1340, isBoss: false },
  { id: 80, level: 80, title: "【ボス】投資の巨匠", description: "巨匠の領域", conditions: ["25年間の投資を完全総括した", "すべての技術を習得した", "圧倒的な実績を残した", "投資界の巨匠となった", "巨匠の称号を得た"], gold: 1650, exp: 3300, isBoss: true },
  
  { id: 81, level: 81, title: "機械学習と投資", description: "AIを投資に活用する", conditions: ["機械学習の基礎を学習した", "投資への応用事例を調査した", "活用可能性を検討した"], gold: 680, exp: 1360, isBoss: false },
  { id: 82, level: 82, title: "高頻度取引の理解", description: "HFTの世界を知る", conditions: ["HFTの仕組みを学習した", "市場への影響を理解した", "個人投資家との関係を把握した"], gold: 690, exp: 1380, isBoss: false },
  { id: 83, level: 83, title: "リスク管理の極致", description: "VaR・CVaRをマスターする", conditions: ["高度なリスク指標を学習した", "ストレステストを実施した", "リスク管理体制を構築した"], gold: 700, exp: 1400, isBoss: false },
  { id: 84, level: 84, title: "デリバティブ戦略", description: "先物・オプションを活用する", conditions: ["カバードコールを学習した", "プロテクティブプットを理解した", "戦略の適用を決定した"], gold: 710, exp: 1420, isBoss: false },
  { id: 85, level: 85, title: "【ボス】神話級の実力", description: "神話の領域へ", conditions: ["30年間の投資人生を総括した", "すべての目標を達成した", "投資界の神話となった", "完璧な投資家として認められた", "神話の称号を得た"], gold: 1750, exp: 3500, isBoss: true },
  
  { id: 86, level: 86, title: "アービトラージ戦略", description: "裁定取引を理解する", conditions: ["市場の非効率性を学習した", "アービトラージ機会を理解した", "個人での実践可能性を評価した"], gold: 720, exp: 1440, isBoss: false },
  { id: 87, level: 87, title: "マルチアセット戦略", description: "全資産クラスを統合する", conditions: ["資産間相関を分析した", "最適配分を計算した", "動的配分戦略を確立した"], gold: 730, exp: 1460, isBoss: false },
  { id: 88, level: 88, title: "グローバル資産管理", description: "世界中の資産を統括する", conditions: ["海外口座を開設した", "通貨分散を実践した", "グローバルポートフォリオを構築した"], gold: 740, exp: 1480, isBoss: false },
  { id: 89, level: 89, title: "ファミリーオフィス", description: "一族の資産を管理する", conditions: ["ファミリーオフィスの概念を学習した", "資産管理体制を構築した", "次世代への教育を開始した"], gold: 750, exp: 1500, isBoss: false },
  { id: 90, level: 90, title: "【ボス】投資の神", description: "神の領域", conditions: ["35年間の投資を完全総括した", "完璧なる投資家になった", "投資の神として崇められた", "不朽の業績を残した", "神の称号を得た"], gold: 1850, exp: 3700, isBoss: true },
  
  { id: 91, level: 91, title: "フィランソロピー戦略", description: "社会貢献と投資を融合", conditions: ["寄付戦略を学習した", "インパクト測定を理解した", "社会貢献計画を立てた"], gold: 800, exp: 1600, isBoss: false },
  { id: 92, level: 92, title: "資産保全の極意", description: "富を守り抜く", conditions: ["資産保護トラストを学習した", "法的保護策を理解した", "包括的保全策を実施した"], gold: 850, exp: 1700, isBoss: false },
  { id: 93, level: 93, title: "長期ビジョン投資", description: "100年先を見据える", conditions: ["超長期投資を学習した", "世代を超えた計画を立てた", "永続的な資産形成戦略を確立した"], gold: 900, exp: 1800, isBoss: false },
  { id: 94, level: 94, title: "グローバルガバナンス", description: "資産統治を完璧にする", conditions: ["ガバナンス構造を設計した", "意思決定プロセスを確立した", "後継者計画を完成させた"], gold: 950, exp: 1900, isBoss: false },
  { id: 95, level: 95, title: "【ボス】投資の悟り", description: "悟りの境地", conditions: ["40年間の投資を完全総括した", "投資の本質を完全に理解した", "悟りを開いた", "完全なる投資家として認められた", "悟りの称号を得た"], gold: 2000, exp: 4000, isBoss: true },
  
  { id: 96, level: 96, title: "投資の芸術性", description: "科学と芸術の融合", conditions: ["投資の美学を追求した", "独自の投資スタイルを確立した", "芸術作品レベルのポートフォリオを構築した"], gold: 1000, exp: 2000, isBoss: false },
  { id: 97, level: 97, title: "レガシーの創造", description: "後世に残る遺産を作る", conditions: ["家族憲章を作成した", "価値観を明文化した", "永続的な仕組みを構築した"], gold: 1100, exp: 2200, isBoss: false },
  { id: 98, level: 98, title: "投資教育の体系化", description: "知識を次世代に伝える", conditions: ["教育カリキュラムを作成した", "メンタープログラムを開始した", "投資塾を開講した"], gold: 1200, exp: 2400, isBoss: false },
  { id: 99, level: 99, title: "投資哲学の昇華", description: "思想レベルに到達する", conditions: ["投資哲学書を出版した", "学術的貢献をした", "思想として認められた"], gold: 1300, exp: 2600, isBoss: false },
  { id: 100, level: 100, title: "【最終ボス】投資神への昇華", description: "投資の創造神となる", conditions: ["50年間の投資人生を完全総括した", "すべてのクエストを完了した", "すべての神器を収集した", "完全なる投資家として認められた", "投資神として永遠に語り継がれる"], gold: 5000, exp: 10000, isBoss: true },
];

// ========================================
// 100 ARTIFACTS - 投資の神器コレクション
// ========================================
const ARTIFACTS = [
  // Common (40個) - 基礎的な投資ツール
  { id: 'c1', name: '堅実なる銀の盾', rarity: 'common', description: '初心者の守りを固める', atk: 1, def: 3, int: 1 },
  { id: 'c2', name: '見習いの短剣', rarity: 'common', description: '投資への第一歩', atk: 3, def: 1, int: 1 },
  { id: 'c3', name: '知恵の初級書', rarity: 'common', description: '基礎知識の結晶', atk: 1, def: 1, int: 3 },
  { id: 'c4', name: '節約の指輪', rarity: 'common', description: '無駄を削ぎ落とす', atk: 2, def: 2, int: 1 },
  { id: 'c5', name: '貯蓄の壺', rarity: 'common', description: 'コツコツ貯める力', atk: 2, def: 1, int: 2 },
  { id: 'c6', name: '家計簿の巻物', rarity: 'common', description: '収支を把握する', atk: 1, def: 2, int: 2 },
  { id: 'c7', name: '小銭入れ', rarity: 'common', description: '日々の備え', atk: 2, def: 2, int: 1 },
  { id: 'c8', name: '預金通帳', rarity: 'common', description: '安全な保管', atk: 1, def: 3, int: 1 },
  { id: 'c9', name: '給与明細', rarity: 'common', description: '収入の源', atk: 3, def: 1, int: 1 },
  { id: 'c10', name: '電卓', rarity: 'common', description: '計算の友', atk: 1, def: 1, int: 3 },
  { id: 'c11', name: '投資入門書', rarity: 'common', description: '知識の扉', atk: 1, def: 2, int: 2 },
  { id: 'c12', name: '定期預金証書', rarity: 'common', description: '確実な成長', atk: 2, def: 3, int: 0 },
  { id: 'c13', name: '緊急資金箱', rarity: 'common', description: '万が一の備え', atk: 0, def: 4, int: 1 },
  { id: 'c14', name: '領収書ファイル', rarity: 'common', description: '支出の記録', atk: 1, def: 2, int: 2 },
  { id: 'c15', name: '目標設定シート', rarity: 'common', description: '夢への地図', atk: 2, def: 1, int: 2 },
  { id: 'c16', name: '銀行印', rarity: 'common', description: '信頼の証', atk: 1, def: 3, int: 1 },
  { id: 'c17', name: '財布', rarity: 'common', description: '日常の管理', atk: 2, def: 2, int: 1 },
  { id: 'c18', name: '経済新聞', rarity: 'common', description: '世界を知る', atk: 1, def: 1, int: 3 },
  { id: 'c19', name: '投資日記', rarity: 'common', description: '記録は力', atk: 1, def: 2, int: 2 },
  { id: 'c20', name: 'セミナー受講証', rarity: 'common', description: '学びの証', atk: 1, def: 1, int: 3 },
  { id: 'c21', name: '証券口座開設書', rarity: 'common', description: '投資への扉', atk: 2, def: 1, int: 2 },
  { id: 'c22', name: '積立設定書', rarity: 'common', description: '継続の力', atk: 3, def: 1, int: 1 },
  { id: 'c23', name: 'リスク評価シート', rarity: 'common', description: '己を知る', atk: 1, def: 2, int: 2 },
  { id: 'c24', name: '投資方針書', rarity: 'common', description: '信念の記録', atk: 2, def: 2, int: 1 },
  { id: 'c25', name: '資産一覧表', rarity: 'common', description: '全体を見る', atk: 1, def: 2, int: 2 },
  { id: 'c26', name: '配当記録帳', rarity: 'common', description: '収穫の記録', atk: 2, def: 1, int: 2 },
  { id: 'c27', name: '手数料比較表', rarity: 'common', description: 'コスト意識', atk: 1, def: 1, int: 3 },
  { id: 'c28', name: '分散投資チャート', rarity: 'common', description: 'リスク分散', atk: 1, def: 3, int: 1 },
  { id: 'c29', name: '目論見書', rarity: 'common', description: '商品理解', atk: 1, def: 2, int: 2 },
  { id: 'c30', name: '取引報告書', rarity: 'common', description: '履歴の証', atk: 2, def: 1, int: 2 },
  { id: 'c31', name: '確定申告書', rarity: 'common', description: '納税の義務', atk: 1, def: 2, int: 2 },
  { id: 'c32', name: 'ポートフォリオ表', rarity: 'common', description: '資産配分', atk: 2, def: 2, int: 1 },
  { id: 'c33', name: '投資カレンダー', rarity: 'common', description: '計画的実行', atk: 2, def: 1, int: 2 },
  { id: 'c34', name: 'マイナンバーカード', rarity: 'common', description: '本人確認', atk: 1, def: 3, int: 1 },
  { id: 'c35', name: 'パスワード管理帳', rarity: 'common', description: 'セキュリティ', atk: 0, def: 4, int: 1 },
  { id: 'c36', name: '投資格言集', rarity: 'common', description: '先人の知恵', atk: 1, def: 1, int: 3 },
  { id: 'c37', name: 'チェックリスト', rarity: 'common', description: '確認の習慣', atk: 1, def: 2, int: 2 },
  { id: 'c38', name: '月次報告書', rarity: 'common', description: '定期点検', atk: 2, def: 1, int: 2 },
  { id: 'c39', name: '資産推移グラフ', rarity: 'common', description: '成長の軌跡', atk: 2, def: 2, int: 1 },
  { id: 'c40', name: '投資仲間リスト', rarity: 'common', description: '絆の力', atk: 2, def: 2, int: 1 },
  
  // Uncommon (30個) - 実践的な投資手法
  { id: 'u1', name: 'インデックスの剣', rarity: 'uncommon', description: '市場平均を切り裂く', atk: 7, def: 3, int: 5 },
  { id: 'u2', name: '分散の盾', rarity: 'uncommon', description: 'リスクを和らげる', atk: 3, def: 8, int: 4 },
  { id: 'u3', name: '知識の書', rarity: 'uncommon', description: '投資理論の集大成', atk: 4, def: 4, int: 7 },
  { id: 'u4', name: 'NISA口座', rarity: 'uncommon', description: '税制優遇の恩恵', atk: 6, def: 5, int: 4 },
  { id: 'u5', name: 'iDeCoの兜', rarity: 'uncommon', description: '老後を守る', atk: 4, def: 7, int: 4 },
  { id: 'u6', name: '複利の指輪', rarity: 'uncommon', description: '時間が力を増幅', atk: 6, def: 4, int: 5 },
  { id: 'u7', name: '配当再投資の鎧', rarity: 'uncommon', description: '収穫を次に繋ぐ', atk: 5, def: 6, int: 4 },
  { id: 'u8', name: 'ドルコスト平均法の杖', rarity: 'uncommon', description: '時間分散の魔法', atk: 5, def: 5, int: 5 },
  { id: 'u9', name: 'リバランスの天秤', rarity: 'uncommon', description: 'バランスを保つ', atk: 4, def: 5, int: 6 },
  { id: 'u10', name: 'ETFの弓', rarity: 'uncommon', description: '分散と低コスト', atk: 7, def: 4, int: 4 },
  { id: 'u11', name: '目論見書解読メガネ', rarity: 'uncommon', description: '真実を見抜く', atk: 3, def: 4, int: 8 },
  { id: 'u12', name: '積立自動設定装置', rarity: 'uncommon', description: '継続を自動化', atk: 6, def: 5, int: 4 },
  { id: 'u13', name: '手数料削減の斧', rarity: 'uncommon', description: 'コストを叩き斬る', atk: 7, def: 3, int: 5 },
  { id: 'u14', name: '長期投資の杖', rarity: 'uncommon', description: '時を味方につける', atk: 5, def: 6, int: 4 },
  { id: 'u15', name: 'アセットアロケーション設計図', rarity: 'uncommon', description: '最適配分の青写真', atk: 4, def: 5, int: 6 },
  { id: 'u16', name: '為替リスク管理マント', rarity: 'uncommon', description: '通貨変動を和らげる', atk: 4, def: 7, int: 4 },
  { id: 'u17', name: 'セクター分析レンズ', rarity: 'uncommon', description: '業種を見極める', atk: 5, def: 4, int: 6 },
  { id: 'u18', name: '損益通算の巻物', rarity: 'uncommon', description: '税を最適化', atk: 5, def: 5, int: 5 },
  { id: 'u19', name: '緊急資金の砦', rarity: 'uncommon', description: '万全の備え', atk: 3, def: 8, int: 4 },
  { id: 'u20', name: '投資方針書マスター版', rarity: 'uncommon', description: '信念の結晶', atk: 5, def: 5, int: 5 },
  { id: 'u21', name: 'ポートフォリオ分析ツール', rarity: 'uncommon', description: '全体を俯瞰', atk: 4, def: 4, int: 7 },
  { id: 'u22', name: 'リスク許容度測定器', rarity: 'uncommon', description: '己の器を知る', atk: 4, def: 5, int: 6 },
  { id: 'u23', name: '投資日記デラックス版', rarity: 'uncommon', description: '詳細な記録', atk: 5, def: 4, int: 6 },
  { id: 'u24', name: 'ベンチマーク比較表', rarity: 'uncommon', description: '成果を測る', atk: 6, def: 4, int: 5 },
  { id: 'u25', name: 'ファミリー投資計画書', rarity: 'uncommon', description: '家族の未来設計', atk: 5, def: 5, int: 5 },
  { id: 'u26', name: 'REITの鍵', rarity: 'uncommon', description: '不動産への扉', atk: 6, def: 5, int: 4 },
  { id: 'u27', name: '債券バランサー', rarity: 'uncommon', description: '守りの資産', atk: 4, def: 7, int: 4 },
  { id: 'u28', name: 'ESG投資コンパス', rarity: 'uncommon', description: '持続可能な道', atk: 5, def: 5, int: 5 },
  { id: 'u29', name: '配当貴族の紋章', rarity: 'uncommon', description: '安定した収入源', atk: 6, def: 5, int: 4 },
  { id: 'u30', name: '投資コミュニティパス', rarity: 'uncommon', description: '仲間との絆', atk: 5, def: 5, int: 5 },
  
  // Rare (20個) - 高度な投資戦略
  { id: 'r1', name: '全世界株式の宝玉', rarity: 'rare', description: '世界経済の成長を掴む', atk: 12, def: 8, int: 10 },
  { id: 'r2', name: '先進国株式の聖剣', rarity: 'rare', description: '成熟市場の力', atk: 14, def: 7, int: 9 },
  { id: 'r3', name: '新興国株式の魔剣', rarity: 'rare', description: '成長の奔流', atk: 16, def: 5, int: 9 },
  { id: 'r4', name: '不落の債券盾', rarity: 'rare', description: '守りを固める', atk: 7, def: 15, int: 8 },
  { id: 'r5', name: '賢者の投資理論書', rarity: 'rare', description: '深い知識の源', atk: 8, def: 8, int: 14 },
  { id: 'r6', name: 'ウォーレン・バフェットの手紙', rarity: 'rare', description: '伝説の教え', atk: 10, def: 9, int: 11 },
  { id: 'r7', name: 'ベンジャミン・グレアムの盾', rarity: 'rare', description: 'バリュー投資の礎', atk: 9, def: 12, int: 9 },
  { id: 'r8', name: 'ジョン・ボーグルの杖', rarity: 'rare', description: 'インデックスの父', atk: 11, def: 9, int: 10 },
  { id: 'r9', name: 'ピーター・リンチの望遠鏡', rarity: 'rare', description: '成長株を見抜く', atk: 13, def: 7, int: 10 },
  { id: 'r10', name: 'レイ・ダリオの羅針盤', rarity: 'rare', description: '全天候型戦略', atk: 10, def: 10, int: 10 },
  { id: 'r11', name: '行動経済学の魔導書', rarity: 'rare', description: '心理の罠を避ける', atk: 8, def: 9, int: 13 },
  { id: 'r12', name: 'ファクター投資の聖典', rarity: 'rare', description: 'リターンの源泉', atk: 12, def: 8, int: 10 },
  { id: 'r13', name: 'リスクパリティの秤', rarity: 'rare', description: 'リスクで測る', atk: 9, def: 11, int: 10 },
  { id: 'r14', name: '税務最適化の魔法陣', rarity: 'rare', description: '効率を極める', atk: 10, def: 10, int: 10 },
  { id: 'r15', name: '相続対策の秘伝書', rarity: 'rare', description: '次世代へ繋ぐ', atk: 9, def: 11, int: 10 },
  { id: 'r16', name: 'ポートフォリオ最適化エンジン', rarity: 'rare', description: '科学的配分', atk: 10, def: 9, int: 11 },
  { id: 'r17', name: 'グローバル投資の地図', rarity: 'rare', description: '世界を股にかける', atk: 12, def: 8, int: 10 },
  { id: 'r18', name: 'オルタナティブ投資の鍵', rarity: 'rare', description: '新たな可能性', atk: 11, def: 9, int: 10 },
  { id: 'r19', name: '複利72の法則の指輪', rarity: 'rare', description: '倍増の魔法', atk: 13, def: 8, int: 9 },
  { id: 'r20', name: '長期投資家の王冠', rarity: 'rare', description: '時間の王者', atk: 11, def: 10, int: 9 },
  
  // Legendary (10個) - 究極の投資神器
  { id: 'l1', name: 'S&P500の聖剣エクスカリバー', rarity: 'legendary', description: '米国500社の力を宿す伝説の剣', atk: 25, def: 15, int: 20 },
  { id: 'l2', name: '時空を超える複利の宝玉', rarity: 'legendary', description: '時間を味方につける究極の力', atk: 20, def: 20, int: 20 },
  { id: 'l3', name: '投資神の叡智の書', rarity: 'legendary', description: 'すべての投資知識を内包する', atk: 18, def: 18, int: 24 },
  { id: 'l4', name: '不死鳥の如き分散ポートフォリオ', rarity: 'legendary', description: '暴落から何度でも蘇る', atk: 20, def: 22, int: 18 },
  { id: 'l5', name: '全世界経済成長の魔剣', rarity: 'legendary', description: '人類の発展そのものが力', atk: 23, def: 17, int: 20 },
  { id: 'l6', name: '完璧なるアセットアロケーション', rarity: 'legendary', description: 'リスクとリターンの究極調和', atk: 20, def: 20, int: 20 },
  { id: 'l7', name: '市場の見えざる手', rarity: 'legendary', description: 'アダム・スミスの神髄', atk: 22, def: 18, int: 20 },
  { id: 'l8', name: '永遠の配当成長株コレクション', rarity: 'legendary', description: '尽きることなき収穫', atk: 21, def: 19, int: 20 },
  { id: 'l9', name: '投資の悟りを開いた者の証', rarity: 'legendary', description: '投資の真理を体得した証', atk: 20, def: 20, int: 20 },
  { id: 'l10', name: '富と自由への黄金の鍵', rarity: 'legendary', description: '経済的自立への最終回答', atk: 24, def: 16, int: 20 },
];

const DAILY_QUEST_POOL = [
  { id: 'd1', title: "市場チェック", description: "今日の市場動向を確認する", conditions: ["主要指数の動きを確認した", "為替レートをチェックした"], gold: 50, exp: 40 },
  { id: 'd2', title: "ポートフォリオ確認", description: "保有資産の状況を把握する", conditions: ["資産残高を確認した", "評価損益を確認した"], gold: 50, exp: 40 },
  { id: 'd3', title: "投資ニュース", description: "最新の投資情報を収集", conditions: ["経済ニュースを3本読んだ", "重要な情報をメモした"], gold: 50, exp: 40 },
  { id: 'd4', title: "支出記録", description: "今日の支出を記録する", conditions: ["レシートを整理した", "家計簿をつけた"], gold: 50, exp: 40 },
  { id: 'd5', title: "投資学習", description: "15分間の投資勉強", conditions: ["投資関連の記事を読んだ", "新しい知識を1つ得た"], gold: 50, exp: 40 },
  { id: 'd6', title: "リスク確認", description: "ポートフォリオのリスクをチェック", conditions: ["資産配分を確認した", "リスクレベルを評価した"], gold: 50, exp: 40 },
  { id: 'd7', title: "投資日記", description: "今日の投資活動を記録", conditions: ["日記を書いた", "学びをメモした"], gold: 50, exp: 40 },
  { id: 'd8', title: "節約実践", description: "無駄な支出を減らす", conditions: ["不要な買い物を1つ我慢した", "節約金額をメモした"], gold: 50, exp: 40 },
  { id: 'd9', title: "投資シミュレーション", description: "投資計画を練る", conditions: ["将来の投資額を試算した", "目標を再確認した"], gold: 50, exp: 40 },
  { id: 'd10', title: "配当確認", description: "配当金の状況をチェック", conditions: ["配当スケジュールを確認した", "再投資計画を見直した"], gold: 50, exp: 40 },
  { id: 'd11', title: "手数料チェック", description: "コストを意識する", conditions: ["保有商品の手数料を確認した", "コスト削減を検討した"], gold: 50, exp: 40 },
  { id: 'd12', title: "リバランス検討", description: "資産配分を見直す", conditions: ["目標配分と現状を比較した", "調整の必要性を判断した"], gold: 50, exp: 40 },
  { id: 'd13', title: "税務意識", description: "税金について考える", conditions: ["税制優遇制度を確認した", "節税策を検討した"], gold: 50, exp: 40 },
  { id: 'd14', title: "投資仲間と交流", description: "情報交換をする", conditions: ["投資コミュニティで交流した", "有益な情報を1つ得た"], gold: 50, exp: 40 },
  { id: 'd15', title: "長期視点の確認", description: "目標を再確認する", conditions: ["投資目標を見直した", "モチベーションを高めた"], gold: 50, exp: 40 },
  { id: 'd16', title: "経済指標", description: "マクロ経済をチェック", conditions: ["重要な経済指標を確認した", "市場への影響を考えた"], gold: 50, exp: 40 },
  { id: 'd17', title: "投資書籍", description: "投資本を読む", conditions: ["投資本を10ページ読んだ", "学びをメモした"], gold: 50, exp: 40 },
  { id: 'd18', title: "緊急資金確認", description: "備えをチェックする", conditions: ["緊急資金の残高を確認した", "十分かどうか評価した"], gold: 50, exp: 40 },
  { id: 'd19', title: "投資メンタル", description: "心理状態をチェック", conditions: ["感情的になっていないか確認した", "冷静な判断を心がけた"], gold: 50, exp: 40 },
  { id: 'd20', title: "感謝の気持ち", description: "投資できることに感謝", conditions: ["投資できる環境に感謝した", "前向きな気持ちを確認した"], gold: 50, exp: 40 },
];

const MONTHLY_QUEST_POOL = [
  { id: 'm1', title: "月次レビュー", description: "今月の投資成果を総括", conditions: ["月間収支を計算した", "目標達成度を評価した", "来月の計画を立てた"], gold: 300, exp: 200 },
  { id: 'm2', title: "ポートフォリオ分析", description: "資産全体を詳細分析", conditions: ["資産配分を確認した", "リバランスの必要性を判断した", "改善点をリストアップした"], gold: 300, exp: 200 },
  { id: 'm3', title: "積立実行", description: "定期積立を実施", conditions: ["予定通り積立を実行した", "積立額を記録した", "継続を誓った"], gold: 300, exp: 200 },
  { id: 'm4', title: "投資書籍完読", description: "投資本を1冊読み切る", conditions: ["投資本を1冊完読した", "学びをまとめた", "実践に活かす計画を立てた"], gold: 300, exp: 200 },
  { id: 'm5', title: "手数料最適化", description: "コストを徹底的に見直す", conditions: ["全保有商品の手数料を確認した", "高コスト商品を特定した", "改善策を実施した"], gold: 300, exp: 200 },
  { id: 'm6', title: "税務対策", description: "税金対策を実施", conditions: ["税制優遇制度を活用した", "損益通算を検討した", "節税策を実行した"], gold: 300, exp: 200 },
  { id: 'm7', title: "投資方針書更新", description: "投資方針を見直す", conditions: ["現在の方針を確認した", "必要な修正を加えた", "更新版を保存した"], gold: 300, exp: 200 },
  { id: 'm8', title: "リスク管理", description: "リスク対策を強化", conditions: ["リスク許容度を再評価した", "リスク分散を確認した", "保険を見直した"], gold: 300, exp: 200 },
  { id: 'm9', title: "投資コミュニティ", description: "他の投資家と交流", conditions: ["投資セミナーに参加した", "投資仲間と意見交換した", "新しい視点を得た"], gold: 300, exp: 200 },
  { id: 'm10', title: "新規投資検討", description: "投資先を調査する", conditions: ["新しい投資商品を調査した", "メリット・デメリットを分析した", "投資判断を下した"], gold: 300, exp: 200 },
  { id: 'm11', title: "配当金管理", description: "配当収入を最適化", conditions: ["配当金を確認した", "再投資計画を更新した", "配当成長を評価した"], gold: 300, exp: 200 },
  { id: 'm12', title: "パフォーマンス測定", description: "運用成績を評価", conditions: ["ベンチマークと比較した", "要因分析をした", "改善策を考えた"], gold: 300, exp: 200 },
  { id: 'm13', title: "マクロ経済分析", description: "経済環境を分析", conditions: ["経済指標をまとめた", "市場動向を分析した", "投資戦略への影響を考えた"], gold: 300, exp: 200 },
  { id: 'm14', title: "投資目標確認", description: "長期目標を見直す", conditions: ["最終目標を確認した", "進捗を評価した", "軌道修正の必要性を判断した"], gold: 300, exp: 200 },
  { id: 'm15', title: "家族との共有", description: "投資方針を家族と共有", conditions: ["家族に現状を報告した", "理解を得た", "協力体制を確認した"], gold: 300, exp: 200 },
  { id: 'm16', title: "緊急資金メンテナンス", description: "備えを万全にする", conditions: ["緊急資金の十分性を確認した", "必要に応じて追加した", "アクセス方法を確認した"], gold: 300, exp: 200 },
  { id: 'm17', title: "投資知識アップデート", description: "最新情報をキャッチアップ", conditions: ["新しい投資トレンドを学習した", "法改正をチェックした", "知識をアップデートした"], gold: 300, exp: 200 },
  { id: 'm18', title: "メンタル強化", description: "投資心理を鍛える", conditions: ["行動経済学を学習した", "自分のバイアスを確認した", "感情コントロール法を実践した"], gold: 300, exp: 200 },
  { id: 'm19', title: "投資記録の整理", description: "記録を体系化する", conditions: ["投資記録を整理した", "データベース化した", "分析しやすくした"], gold: 300, exp: 200 },
  { id: 'm20', title: "感謝と振り返り", description: "今月を総括する", conditions: ["今月の良かった点をリストアップした", "改善点を明確にした", "来月への意気込みを確認した"], gold: 300, exp: 200 },
];

const TITLES = [
  { level: 1, title: '迷える子羊' },
  { level: 5, title: '見習い投資家' },
  { level: 10, title: '初心者投資家' },
  { level: 15, title: '駆け出し投資家' },
  { level: 20, title: '一人前の投資家' },
  { level: 25, title: '熟練投資家' },
  { level: 30, title: '中堅投資家' },
  { level: 35, title: '上級投資家' },
  { level: 40, title: 'ベテラン投資家' },
  { level: 45, title: 'エキスパート投資家' },
  { level: 50, title: 'マスター投資家' },
  { level: 55, title: '投資の達人' },
  { level: 60, title: '投資マエストロ' },
  { level: 65, title: '賢者なる投資家' },
  { level: 70, title: '投資の覇者' },
  { level: 75, title: '伝説の投資家' },
  { level: 80, title: '投資の巨匠' },
  { level: 85, title: '神話級投資家' },
  { level: 90, title: '投資の神' },
  { level: 95, title: '全知全能の投資神' },
  { level: 100, title: '投資の創造神' },
];

const seedRandom = (seed) => {
  let value = seed;
  return () => {
    value = (value * 9301 + 49297) % 233280;
    return value / 233280;
  };
};

const getRandomFromArray = (array, count, seed) => {
  const rng = seedRandom(seed);
  const shuffled = [...array].sort(() => rng() - 0.5);
  return shuffled.slice(0, count);
};

const getDailyQuests = (requiredExp) => {
  const today = new Date();
  const seed = today.getFullYear() * 10000 + (today.getMonth() + 1) * 100 + today.getDate();
  const quests = getRandomFromArray(DAILY_QUEST_POOL, Math.min(3, DAILY_QUEST_POOL.length), seed);
  return quests.map(elem => ({
    ...elem,
    exp: elem.exp + Math.floor(requiredExp / 3)
  }));
};

const getMonthlyQuests = (requiredExp) => {
  const today = new Date();
  const seed = today.getFullYear() * 100 + (today.getMonth() + 1);
  const quests = getRandomFromArray(MONTHLY_QUEST_POOL, Math.min(3, MONTHLY_QUEST_POOL.length), seed);
  return quests.map(elem => ({
    ...elem,
    exp: elem.exp * 5 + requiredExp
  }));
};

const calculateLevel = (exp) => {
  let level = 1;
  let requiredExp = 100;
  let totalExp = 0;
  
  while (totalExp + requiredExp <= exp) {
    totalExp += requiredExp;
    level++;
    requiredExp = Math.floor(100 * Math.pow(1.1, level - 1));
  }
  
  return { level, currentExp: exp - totalExp, requiredExp, totalExp };
};

const getTitle = (level) => {
  for (let i = TITLES.length - 1; i >= 0; i--) {
    if (level >= TITLES[i].level) return TITLES[i].title;
  }
  return TITLES[0].title;
};

const calculateGachaRates = (level) => {
  const baseCommon = 70;
  const reduction = Math.min(level * 0.3, 40);
  const common = Math.max(baseCommon - reduction, 30);
  const increase = (baseCommon - common) / 3;
  
  return {
    common,
    uncommon: 20 + increase,
    rare: 8 + increase,
    legendary: 2 + increase
  };
};

const rollGacha = (level) => {
  const rates = calculateGachaRates(level);
  const roll = Math.random() * 100;
  
  let rarity;
  if (roll < rates.legendary) rarity = 'legendary';
  else if (roll < rates.legendary + rates.rare) rarity = 'rare';
  else if (roll < rates.legendary + rates.rare + rates.uncommon) rarity = 'uncommon';
  else rarity = 'common';
  
  const pool = ARTIFACTS.filter(a => a.rarity === rarity);
  return pool[Math.floor(Math.random() * pool.length)];
};

export default function InvestorQuestV2() {
  const [playerData, setPlayerData] = useState(() => {
    if (typeof localStorage !== 'undefined') {
      const saved = localStorage.getItem('investorQuestV2');
      if (saved) return JSON.parse(saved);
    }
    return {
      exp: 0,
      gold: 0,
      completedMainQuests: [],
      completedDailyQuests: [],
      completedMonthlyQuests: [],
      artifacts: [],
      duplicates: {},
      streak: 0,
      lastLogin: new Date().toISOString().split('T')[0]
    };
  });

  const [currentView, setCurrentView] = useState('home');
  const [selectedQuest, setSelectedQuest] = useState(null);
  const [gachaAnimation, setGachaAnimation] = useState(null);
  const [showLevelUp, setShowLevelUp] = useState(null);
  const [notification, setNotification] = useState(null);

  useEffect(() => {
    if (typeof localStorage !== 'undefined') {
      localStorage.setItem('investorQuestV2', JSON.stringify(playerData));
    }
  }, [playerData]);

  useEffect(() => {
    const today = new Date().toISOString().split('T')[0];
    const currentMonth = today.substring(0, 7);
    const lastLoginMonth = playerData.lastLogin.substring(0, 7);
    if (lastLoginMonth !== currentMonth) {
      playerData.completedMonthlyQuests = [];
    }
    if (playerData.lastLogin !== today) {
      const lastDate = new Date(playerData.lastLogin);
      const todayDate = new Date(today);
      const daysDiff = Math.floor((todayDate - lastDate) / (1000 * 60 * 60 * 24));
      setPlayerData(prev => ({
        ...prev,
        lastLogin: today,
        streak: daysDiff === 1 ? prev.streak + 1 : 1,
        completedDailyQuests: []
      }));
    }
  }, []);

  const levelInfo = calculateLevel(playerData.exp);
  const title = getTitle(levelInfo.level);
  
  const baseStats = {
    atk: levelInfo.level * 2,
    def: levelInfo.level * 2,
    int: levelInfo.level * 2
  };
  
  const artifactStats = playerData.artifacts.reduce((acc, artifactId) => {
    const artifact = ARTIFACTS.find(a => a.id === artifactId);
    if (artifact) {
      acc.atk += artifact.atk;
      acc.def += artifact.def;
      acc.int += artifact.int;
    }
    return acc;
  }, { atk: 0, def: 0, int: 0 });
  
  const totalStats = {
    atk: baseStats.atk + artifactStats.atk,
    def: baseStats.def + artifactStats.def,
    int: baseStats.int + artifactStats.int
  };

  const showNotification = (message, type = 'success') => {
    setNotification({ message, type });
    setTimeout(() => setNotification(null), 3000);
  };

  const completeQuest = (quest, questType) => {
    const oldLevel = levelInfo.level;
    const newExp = playerData.exp + quest.exp;
    const newGold = playerData.gold + quest.gold;
    const newLevelInfo = calculateLevel(newExp);
    
    setPlayerData(prev => ({
      ...prev,
      exp: newExp,
      gold: newGold,
      [`completed${questType}Quests`]: [...prev[`completed${questType}Quests`], quest.id]
    }));
    
    if (newLevelInfo.level > oldLevel) {
      setShowLevelUp({
        oldLevel,
        newLevel: newLevelInfo.level,
        newTitle: getTitle(newLevelInfo.level)
      });
    }
    
    showNotification(`クエスト完了！ +${quest.exp}EXP +${quest.gold}GOLD`);
    setSelectedQuest(null);
  };

  const performGacha = () => {
    if (playerData.gold < 100) {
      showNotification('GOLDが足りません！', 'error');
      return;
    }
    
    const artifact = rollGacha(levelInfo.level);
    setGachaAnimation({ artifact, phase: 'rolling' });
    
    setTimeout(() => {
      setGachaAnimation(prev => ({ ...prev, phase: 'reveal' }));
      
      setTimeout(() => {
        if (playerData.artifacts.includes(artifact.id)) {
          const duplicateKey = artifact.rarity;
          const newCount = (playerData.duplicates[duplicateKey] || 0) + 1;
          
          setPlayerData(prev => ({
            ...prev,
            gold: prev.gold - 100,
            duplicates: { ...prev.duplicates, [duplicateKey]: newCount }
          }));
          
          showNotification('既に所持している神器です！（重複カウント+1）');
        } else {
          setPlayerData(prev => ({
            ...prev,
            gold: prev.gold - 100,
            artifacts: [...prev.artifacts, artifact.id]
          }));
          
          showNotification(`新しい神器を獲得！ ${artifact.name}`);
        }
        
        setGachaAnimation(null);
      }, 3000);
    }, 2000);
  };

  const shareToSNS = async () => {
    const text = `🎮 投資家クエスト 🎮\n\n` +
      `称号: ${title}\nレベル: ${levelInfo.level}\n` +
      `入金力: ${totalStats.atk} | 防御力: ${totalStats.def} | 分析力: ${totalStats.int}\n` +
      `神器コレクション: ${playerData.artifacts.length}/${ARTIFACTS.length}\n` +
      `継続ストリーク: ${playerData.streak}日\n\n#投資RPG #長期投資`;
    
    try {
      if (typeof navigator !== 'undefined' && navigator.clipboard && navigator.clipboard.writeText) {
        await navigator.clipboard.writeText(text);
        showNotification('テキストをコピーしました！');
      } else if (typeof navigator !== 'undefined' && navigator.share) {
        await navigator.share({ text });
      } else {
        // Fallback for older browsers
        const textArea = document.createElement('textarea');
        textArea.value = text;
        textArea.style.position = 'fixed';
        textArea.style.left = '-999999px';
        document.body.appendChild(textArea);
        textArea.select();
        try {
          document.execCommand('copy');
          showNotification('テキストをコピーしました！');
        } catch (err) {
          showNotification('コピーに失敗しました', 'error');
        }
        document.body.removeChild(textArea);
      }
    } catch (err) {
      showNotification('コピーに失敗しました', 'error');
    }
  };

  const renderHome = () => {
    const dailyQuests = getDailyQuests(levelInfo.requiredExp);
    const monthlyQuests = getMonthlyQuests(levelInfo.requiredExp);
    const availableMainQuests = MAIN_QUESTS.filter(q => 
      q.level <= levelInfo.level && !playerData.completedMainQuests.includes(q.id)
    ).slice(0, 5);

    return (
      <div className="space-y-6">
        <div className="relative overflow-hidden rounded-2xl bg-gradient-to-br from-purple-900/40 via-blue-900/40 to-indigo-900/40 p-8 border border-purple-500/20">
          <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_50%,rgba(168,85,247,0.1),transparent_50%)]"></div>
          
          <div className="relative z-10">
            <div className="flex items-center justify-between mb-6">
              <div>
                <div className="flex items-center gap-3 mb-2">
                  <Crown className="w-8 h-8 text-yellow-400" />
                  <h2 className="text-3xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-yellow-200 via-yellow-400 to-yellow-200">
                    {title}
                  </h2>
                </div>
                <p className="text-purple-200 text-lg">Level {levelInfo.level} 投資家</p>
              </div>
              <button
                onClick={shareToSNS}
                className="flex items-center gap-2 px-4 py-2 bg-blue-500/20 hover:bg-blue-500/30 rounded-lg border border-blue-400/30 transition-all"
              >
                <Share2 className="w-5 h-5 text-blue-300" />
                <span className="text-blue-200">シェア</span>
              </button>
            </div>
            
            <div className="grid grid-cols-3 gap-4 mb-6">
              <div className="bg-black/30 rounded-lg p-4 border border-red-500/30">
                <div className="flex items-center gap-2 mb-2">
                  <Sword className="w-5 h-5 text-red-400" />
                  <span className="text-red-200 text-sm">入金力</span>
                </div>
                <p className="text-3xl font-bold text-red-400">{totalStats.atk}</p>
              </div>
              <div className="bg-black/30 rounded-lg p-4 border border-blue-500/30">
                <div className="flex items-center gap-2 mb-2">
                  <Shield className="w-5 h-5 text-blue-400" />
                  <span className="text-blue-200 text-sm">防御力</span>
                </div>
                <p className="text-3xl font-bold text-blue-400">{totalStats.def}</p>
              </div>
              <div className="bg-black/30 rounded-lg p-4 border border-purple-500/30">
                <div className="flex items-center gap-2 mb-2">
                  <Brain className="w-5 h-5 text-purple-400" />
                  <span className="text-purple-200 text-sm">分析力</span>
                </div>
                <p className="text-3xl font-bold text-purple-400">{totalStats.int}</p>
              </div>
            </div>
            
            <div className="space-y-3">
              <div>
                <div className="flex items-center justify-between mb-2">
                  <span className="text-purple-200">EXP</span>
                  <span className="text-purple-300">{levelInfo.currentExp} / {levelInfo.requiredExp}</span>
                </div>
                <div className="h-3 bg-black/40 rounded-full overflow-hidden border border-purple-500/30">
                  <div 
                    className="h-full bg-gradient-to-r from-purple-500 to-pink-500 transition-all duration-500"
                    style={{ width: `${(levelInfo.currentExp / levelInfo.requiredExp) * 100}%` }}
                  ></div>
                </div>
              </div>
              
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-2">
                  <Sparkles className="w-5 h-5 text-yellow-400" />
                  <span className="text-yellow-200 font-semibold">{playerData.gold} GOLD</span>
                </div>
                <div className="flex items-center gap-2">
                  <Zap className="w-5 h-5 text-orange-400" />
                  <span className="text-orange-200">継続 {playerData.streak} 日</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {dailyQuests.length > 0 && (
          <div className="bg-gradient-to-br from-orange-900/20 to-yellow-900/20 rounded-xl p-6 border border-orange-500/30">
            <div className="flex items-center gap-3 mb-4">
              <Calendar className="w-6 h-6 text-orange-400" />
              <h3 className="text-xl font-bold text-orange-200">デイリークエスト</h3>
            </div>
            <div className="space-y-3">
              {dailyQuests.map(quest => (
                <button
                  key={quest.id}
                  onClick={() => setSelectedQuest({ ...quest, type: 'Daily' })}
                  disabled={playerData.completedDailyQuests.includes(quest.id)}
                  className="w-full text-left p-4 bg-black/30 hover:bg-black/40 rounded-lg border border-orange-500/20 transition-all disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  <div className="flex items-center justify-between">
                    <div>
                      <h4 className="font-semibold text-orange-100 mb-1">{quest.title}</h4>
                      <p className="text-sm text-orange-300/70">{quest.description}</p>
                    </div>
                    <div className="flex items-center gap-3">
                      <span className="text-sm text-yellow-300">+{quest.gold}G</span>
                      {playerData.completedDailyQuests.includes(quest.id) && (
                        <Check className="w-5 h-5 text-green-400" />
                      )}
                    </div>
                  </div>
                </button>
              ))}
            </div>
          </div>
        )}

        {monthlyQuests.length > 0 && (
          <div className="bg-gradient-to-br from-blue-900/20 to-cyan-900/20 rounded-xl p-6 border border-blue-500/30">
            <div className="flex items-center gap-3 mb-4">
              <TrendingUp className="w-6 h-6 text-blue-400" />
              <h3 className="text-xl font-bold text-blue-200">マンスリークエスト</h3>
            </div>
            <div className="space-y-3">
              {monthlyQuests.map(quest => (
                <button
                  key={quest.id}
                  onClick={() => setSelectedQuest({ ...quest, type: 'Monthly' })}
                  disabled={playerData.completedMonthlyQuests.includes(quest.id)}
                  className="w-full text-left p-4 bg-black/30 hover:bg-black/40 rounded-lg border border-blue-500/20 transition-all disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  <div className="flex items-center justify-between">
                    <div>
                      <h4 className="font-semibold text-blue-100 mb-1">{quest.title}</h4>
                      <p className="text-sm text-blue-300/70">{quest.description}</p>
                    </div>
                    <div className="flex items-center gap-3">
                      <span className="text-sm text-yellow-300">+{quest.gold}G</span>
                      {playerData.completedMonthlyQuests.includes(quest.id) && (
                        <Check className="w-5 h-5 text-green-400" />
                      )}
                    </div>
                  </div>
                </button>
              ))}
            </div>
          </div>
        )}

        {availableMainQuests.length > 0 && (
          <div className="bg-gradient-to-br from-purple-900/20 to-pink-900/20 rounded-xl p-6 border border-purple-500/30">
            <div className="flex items-center gap-3 mb-4">
              <Target className="w-6 h-6 text-purple-400" />
              <h3 className="text-xl font-bold text-purple-200">メインクエスト</h3>
            </div>
            <div className="space-y-3">
              {availableMainQuests.map(quest => (
                <button
                  key={quest.id}
                  onClick={() => setSelectedQuest({ ...quest, type: 'Main' })}
                  className={`w-full text-left p-4 rounded-lg border transition-all ${
                    quest.isBoss
                      ? 'bg-gradient-to-r from-red-900/30 to-orange-900/30 border-red-500/40 hover:from-red-900/40 hover:to-orange-900/40'
                      : 'bg-black/30 hover:bg-black/40 border-purple-500/20'
                  }`}
                >
                  <div className="flex items-center justify-between">
                    <div className="flex-1">
                      <div className="flex items-center gap-2 mb-1">
                        {quest.isBoss && <Trophy className="w-5 h-5 text-red-400" />}
                        <h4 className="font-semibold text-purple-100">{quest.title}</h4>
                      </div>
                      <p className="text-sm text-purple-300/70">{quest.description}</p>
                    </div>
                    <div className="flex items-center gap-3 ml-4">
                      <span className="text-sm text-yellow-300">+{quest.gold}G</span>
                    </div>
                  </div>
                </button>
              ))}
            </div>
          </div>
        )}
      </div>
    );
  };

  const renderQuests = () => {
    const completedCount = playerData.completedMainQuests.length;
    const totalCount = MAIN_QUESTS.length;
    const progress = (completedCount / totalCount) * 100;

    return (
      <div className="space-y-6">
        <div className="bg-gradient-to-br from-purple-900/40 to-indigo-900/40 rounded-xl p-6 border border-purple-500/30">
          <h3 className="text-xl font-bold text-purple-200 mb-4">クエスト進行状況</h3>
          <div className="mb-2">
            <div className="flex items-center justify-between mb-2">
              <span className="text-purple-300">完了: {completedCount} / {totalCount}</span>
              <span className="text-purple-300">{progress.toFixed(1)}%</span>
            </div>
            <div className="h-4 bg-black/40 rounded-full overflow-hidden border border-purple-500/30">
              <div 
                className="h-full bg-gradient-to-r from-purple-500 via-pink-500 to-purple-500 transition-all duration-500"
                style={{ width: `${progress}%` }}
              ></div>
            </div>
          </div>
        </div>

        <div className="space-y-4">
          {MAIN_QUESTS.map((quest) => {
            const isCompleted = playerData.completedMainQuests.includes(quest.id);
            const isLocked = quest.level > levelInfo.level;
            
            return (
              <div
                key={quest.id}
                className={`rounded-xl p-5 border transition-all ${
                  isCompleted
                    ? 'bg-green-900/20 border-green-500/30'
                    : isLocked
                    ? 'bg-gray-900/20 border-gray-700/30 opacity-50'
                    : quest.isBoss
                    ? 'bg-gradient-to-r from-red-900/30 to-orange-900/30 border-red-500/40'
                    : 'bg-purple-900/20 border-purple-500/30'
                }`}
              >
                <div className="flex items-center justify-between">
                  <div className="flex-1">
                    <div className="flex items-center gap-3 mb-2">
                      {isLocked && <Lock className="w-5 h-5 text-gray-500" />}
                      {quest.isBoss && <Trophy className="w-6 h-6 text-red-400" />}
                      {isCompleted && <Check className="w-5 h-5 text-green-400" />}
                      <div>
                        <h4 className="font-bold text-lg text-purple-100">
                          #{quest.id} {quest.title}
                        </h4>
                        <p className="text-sm text-purple-300/70">{quest.description}</p>
                      </div>
                    </div>
                  </div>
                  <div className="flex flex-col items-end gap-2 ml-4">
                    <span className="text-sm text-purple-300">Lv.{quest.level}</span>
                    <span className="text-yellow-300 font-semibold">+{quest.gold}G</span>
                    {!isCompleted && !isLocked && (
                      <button
                        onClick={() => setSelectedQuest({ ...quest, type: 'Main' })}
                        className="px-4 py-1 bg-purple-500 hover:bg-purple-600 rounded text-white text-sm transition-colors"
                      >
                        挑戦
                      </button>
                    )}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    );
  };

  const renderGacha = () => {
    const rates = calculateGachaRates(levelInfo.level);

    return (
      <div className="space-y-6">
        <div className="bg-gradient-to-br from-yellow-900/40 to-orange-900/40 rounded-xl p-8 border border-yellow-500/30 text-center">
          <Gift className="w-16 h-16 text-yellow-400 mx-auto mb-4" />
          <h2 className="text-3xl font-bold text-yellow-200 mb-2">神器ガチャ</h2>
          <p className="text-yellow-300/80 mb-6">投資の神器を集めて最強の投資家に！</p>
          
          <div className="flex items-center justify-center gap-4 mb-6">
            <div className="flex items-center gap-2">
              <Sparkles className="w-5 h-5 text-yellow-400" />
              <span className="text-2xl font-bold text-yellow-200">{playerData.gold} GOLD</span>
            </div>
          </div>

          <button
            onClick={performGacha}
            disabled={playerData.gold < 100 || gachaAnimation}
            className="px-8 py-4 bg-gradient-to-r from-yellow-500 to-orange-500 hover:from-yellow-600 hover:to-orange-600 rounded-xl text-white font-bold text-lg transition-all disabled:opacity-50 disabled:cursor-not-allowed shadow-lg"
          >
            ガチャを回す (100 GOLD)
          </button>
        </div>

        <div className="grid grid-cols-2 gap-4">
          <div className="bg-gray-700/30 rounded-lg p-4 border border-gray-500/30">
            <h4 className="text-gray-300 font-semibold mb-2">排出確率</h4>
            <div className="space-y-1 text-sm">
              <div className="flex justify-between"><span className="text-gray-400">Common</span><span className="text-gray-300">{rates.common.toFixed(1)}%</span></div>
              <div className="flex justify-between"><span className="text-blue-400">Uncommon</span><span className="text-blue-300">{rates.uncommon.toFixed(1)}%</span></div>
              <div className="flex justify-between"><span className="text-purple-400">Rare</span><span className="text-purple-300">{rates.rare.toFixed(1)}%</span></div>
              <div className="flex justify-between"><span className="text-yellow-400">Legendary</span><span className="text-yellow-300">{rates.legendary.toFixed(1)}%</span></div>
            </div>
          </div>

          <div className="bg-purple-900/30 rounded-lg p-4 border border-purple-500/30">
            <h4 className="text-purple-300 font-semibold mb-2">重複カウント</h4>
            <div className="space-y-1 text-sm">
              <div className="flex justify-between">
                <span className="text-gray-300">Common</span>
                <span className="text-gray-400">{playerData.duplicates.common || 0}</span>
              </div>
              <div className="flex justify-between">
                <span className="text-blue-300">Uncommon</span>
                <span className="text-blue-400">{playerData.duplicates.uncommon || 0}</span>
              </div>
              <div className="flex justify-between">
                <span className="text-purple-300">Rare</span>
                <span className="text-purple-400">{playerData.duplicates.rare || 0}</span>
              </div>
              <div className="flex justify-between">
                <span className="text-yellow-300">Legendary</span>
                <span className="text-yellow-400">{playerData.duplicates.legendary || 0}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const renderCollection = () => {
    const collectedCount = playerData.artifacts.length;
    const totalCount = ARTIFACTS.length;
    const progress = (collectedCount / totalCount) * 100;

    const groupedArtifacts = {
      legendary: ARTIFACTS.filter(a => a.rarity === 'legendary'),
      rare: ARTIFACTS.filter(a => a.rarity === 'rare'),
      uncommon: ARTIFACTS.filter(a => a.rarity === 'uncommon'),
      common: ARTIFACTS.filter(a => a.rarity === 'common'),
    };

    return (
      <div className="space-y-6">
        <div className="bg-gradient-to-br from-purple-900/40 to-indigo-900/40 rounded-xl p-6 border border-purple-500/30">
          <h3 className="text-xl font-bold text-purple-200 mb-4">コレクション進行度</h3>
          <div className="mb-2">
            <div className="flex items-center justify-between mb-2">
              <span className="text-purple-300">収集: {collectedCount} / {totalCount}</span>
              <span className="text-purple-300">{progress.toFixed(1)}%</span>
            </div>
            <div className="h-4 bg-black/40 rounded-full overflow-hidden border border-purple-500/30">
              <div 
                className="h-full bg-gradient-to-r from-purple-500 via-pink-500 to-yellow-500 transition-all duration-500"
                style={{ width: `${progress}%` }}
              ></div>
            </div>
          </div>
        </div>

        {Object.entries(groupedArtifacts).map(([rarity, artifacts]) => {
          const collected = artifacts.filter(a => playerData.artifacts.includes(a.id)).length;
          const rarityConfig = {
            legendary: { color: 'yellow', label: 'Legendary' },
            rare: { color: 'purple', label: 'Rare' },
            uncommon: { color: 'blue', label: 'Uncommon' },
            common: { color: 'gray', label: 'Common' },
          };
          const config = rarityConfig[rarity];

          return (
            <div key={rarity} className="bg-opacity-20 rounded-xl p-6 border" style={{
              backgroundColor: `rgb(${config.color === 'yellow' ? '133, 77, 14' : config.color === 'purple' ? '88, 28, 135' : config.color === 'blue' ? '30, 58, 138' : '55, 65, 81'} / 0.2)`,
              borderColor: `rgb(${config.color === 'yellow' ? '234, 179, 8' : config.color === 'purple' ? '168, 85, 247' : config.color === 'blue' ? '59, 130, 246' : '156, 163, 175'} / 0.3)`
            }}>
              <div className="flex items-center justify-between mb-4">
                <h4 className="text-xl font-bold" style={{color: config.color === 'yellow' ? '#fde047' : config.color === 'purple' ? '#d8b4fe' : config.color === 'blue' ? '#93c5fd' : '#d1d5db'}}>{config.label}</h4>
                <span style={{color: config.color === 'yellow' ? '#fef08a' : config.color === 'purple' ? '#e9d5ff' : config.color === 'blue' ? '#bfdbfe' : '#e5e7eb'}}>{collected}/{artifacts.length}</span>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                {artifacts.map(artifact => {
                  const isOwned = playerData.artifacts.includes(artifact.id);
                  return (
                    <div
                      key={artifact.id}
                      className={`p-4 rounded-lg border transition-all ${
                        isOwned ? 'opacity-100' : 'opacity-50'
                      }`}
                      style={{
                        backgroundColor: isOwned ? 'rgba(0,0,0,0.3)' : 'rgba(0,0,0,0.2)',
                        borderColor: isOwned ? `rgb(${config.color === 'yellow' ? '234, 179, 8' : config.color === 'purple' ? '168, 85, 247' : config.color === 'blue' ? '59, 130, 246' : '156, 163, 175'} / 0.5)` : 'rgba(75, 85, 99, 0.3)'
                      }}
                    >
                      <div className="flex items-start gap-3">
                        <div className="w-12 h-12 rounded-lg flex items-center justify-center" style={{
                          background: isOwned ? `linear-gradient(to bottom right, ${config.color === 'yellow' ? '#fbbf24, #f59e0b' : config.color === 'purple' ? '#a855f7, #ec4899' : config.color === 'blue' ? '#3b82f6, #06b6d4' : '#9ca3af, #6b7280'})` : '#4b5563'
                        }}>
                          {isOwned ? <Award className="w-6 h-6 text-white" /> : <Lock className="w-6 h-6 text-gray-500" />}
                        </div>
                        <div className="flex-1">
                          <h5 className={`font-bold mb-1 ${isOwned ? 'text-white' : 'text-gray-500'}`}>
                            {artifact.name}
                          </h5>
                          <p className={`text-sm mb-2 ${isOwned ? 'text-gray-300' : 'text-gray-600'}`}>
                            {artifact.description}
                          </p>
                          {isOwned && (
                            <div className="flex gap-3 text-xs">
                              <span className="text-red-400">ATK+{artifact.atk}</span>
                              <span className="text-blue-400">DEF+{artifact.def}</span>
                              <span className="text-purple-400">INT+{artifact.int}</span>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          );
        })}
      </div>
    );
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-purple-900 to-slate-900 text-white p-4">
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Cinzel:wght@400;600;700;900&family=Inter:wght@400;500;600;700&display=swap');
        
        body { 
          font-family: 'Inter', sans-serif;
        }
        h1, h2, h3 {
          font-family: 'Cinzel', serif;
        }
        
        @keyframes float {
          0%, 100% { transform: translateY(0px); }
          50% { transform: translateY(-10px); }
        }
        
        @keyframes glow {
          0%, 100% { box-shadow: 0 0 20px rgba(168, 85, 247, 0.5); }
          50% { box-shadow: 0 0 40px rgba(168, 85, 247, 0.8); }
        }
        
        @keyframes spin-slow {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }
        
        .animate-float {
          animation: float 3s ease-in-out infinite;
        }
        
        .animate-glow {
          animation: glow 2s ease-in-out infinite;
        }
        
        .animate-spin-slow {
          animation: spin-slow 20s linear infinite;
        }
      `}</style>

      <div className="max-w-4xl mx-auto">
        <div className="mb-8 text-center relative">
          <div className="absolute inset-0 flex items-center justify-center opacity-20">
            <Sparkles className="w-32 h-32 text-yellow-400 animate-spin-slow" />
          </div>
          <h1 className="text-5xl font-black mb-2 text-transparent bg-clip-text bg-gradient-to-r from-yellow-200 via-yellow-400 to-yellow-200 relative z-10">
            投資家クエスト
          </h1>
          <p className="text-purple-300 text-lg relative z-10">長期投資を冒険に変える</p>
        </div>

        <div className="mb-6 flex gap-2 bg-black/30 p-2 rounded-xl border border-purple-500/30">
          {[
            { id: 'home', icon: Target, label: 'ホーム' },
            { id: 'quests', icon: Trophy, label: 'クエスト' },
            { id: 'gacha', icon: Gift, label: 'ガチャ' },
            { id: 'collection', icon: Award, label: 'コレクション' },
          ].map(nav => (
            <button
              key={nav.id}
              onClick={() => setCurrentView(nav.id)}
              className={`flex-1 flex items-center justify-center gap-2 px-4 py-3 rounded-lg transition-all ${
                currentView === nav.id
                  ? 'bg-purple-500 text-white shadow-lg'
                  : 'bg-transparent text-purple-300 hover:bg-purple-500/20'
              }`}
            >
              <nav.icon className="w-5 h-5" />
              <span className="text-[10px] sm:text-sm font-semibold">{nav.label}</span>
            </button>
          ))}
        </div>

        <div className="mb-20">
          {currentView === 'home' && renderHome()}
          {currentView === 'quests' && renderQuests()}
          {currentView === 'gacha' && renderGacha()}
          {currentView === 'collection' && renderCollection()}
        </div>
      </div>

      {selectedQuest && (
        <div className="fixed inset-0 bg-black/80 flex items-center justify-center z-50 p-4 overflow-y-auto">
          <div className="bg-gradient-to-br from-purple-900 to-indigo-900 rounded-2xl p-8 max-w-2xl w-full border-2 border-purple-500/50 shadow-2xl my-8">
            <div className="flex items-center gap-3 mb-6">
              {selectedQuest.isBoss && <Trophy className="w-8 h-8 text-red-400" />}
              <h3 className="text-3xl font-bold text-purple-100">{selectedQuest.title}</h3>
            </div>
            
            <p className="text-purple-200 mb-6 text-lg">{selectedQuest.description}</p>
            
            <div className="bg-black/40 rounded-xl p-6 mb-6 border border-purple-500/30">
              <h4 className="text-xl font-bold text-yellow-200 mb-4">✨ 達成条件 ✨</h4>
              <ul className="space-y-3">
                {selectedQuest.conditions.map((condition, idx) => (
                  <li key={idx} className="flex items-start gap-3 text-purple-100">
                    <Check className="w-5 h-5 text-green-400 mt-0.5 flex-shrink-0" />
                    <span>{condition}</span>
                  </li>
                ))}
              </ul>
            </div>
            
            <div className="bg-gradient-to-r from-yellow-900/40 to-orange-900/40 rounded-xl p-6 mb-6 border border-yellow-500/40">
              <p className="text-yellow-100 text-center text-lg font-semibold mb-2">
                あなたは自分に嘘をつかず、この試練を乗り越えましたか？
              </p>
              <p className="text-yellow-300/80 text-center text-sm">
                投資家として、誠実さが最も重要な資質です
              </p>
            </div>
            
            <div className="flex items-center justify-between mb-6">
              <div className="flex gap-4">
                <span className="text-yellow-300 font-bold">報酬: +{selectedQuest.gold} GOLD</span>
                <span className="text-blue-300 font-bold">+{selectedQuest.exp} EXP</span>
              </div>
            </div>
            
            <div className="flex gap-3">
              <button
                onClick={() => completeQuest(selectedQuest, selectedQuest.type)}
                className="flex-1 bg-gradient-to-r from-green-500 to-emerald-500 hover:from-green-600 hover:to-emerald-600 text-white font-bold py-4 rounded-xl transition-all shadow-lg"
              >
                はい、達成しました
              </button>
              <button
                onClick={() => setSelectedQuest(null)}
                className="flex-1 bg-gradient-to-r from-gray-600 to-gray-700 hover:from-gray-700 hover:to-gray-800 text-white font-bold py-4 rounded-xl transition-all"
              >
                まだです
              </button>
            </div>
          </div>
        </div>
      )}

      {gachaAnimation && (
        <div className="fixed inset-0 bg-black/90 flex items-center justify-center z-50">
          <div className="text-center">
            {gachaAnimation.phase === 'rolling' ? (
              <div className="animate-float">
                <Gift className="w-32 h-32 text-yellow-400 mx-auto mb-8 animate-spin-slow" />
                <p className="text-3xl font-bold text-yellow-200">神器を召喚中...</p>
              </div>
            ) : (
              <div className="animate-float">
                <div className={`w-48 h-48 mx-auto mb-8 rounded-2xl flex items-center justify-center animate-glow`} style={{
                  background: gachaAnimation.artifact.rarity === 'legendary' 
                    ? 'linear-gradient(to bottom right, #fbbf24, #f59e0b)'
                    : gachaAnimation.artifact.rarity === 'rare'
                    ? 'linear-gradient(to bottom right, #a855f7, #ec4899)'
                    : gachaAnimation.artifact.rarity === 'uncommon'
                    ? 'linear-gradient(to bottom right, #3b82f6, #06b6d4)'
                    : 'linear-gradient(to bottom right, #9ca3af, #6b7280)'
                }}>
                  <Award className="w-24 h-24 text-white" />
                </div>
                <h3 className="text-4xl font-bold mb-4" style={{
                  color: gachaAnimation.artifact.rarity === 'legendary' ? '#fde047'
                    : gachaAnimation.artifact.rarity === 'rare' ? '#d8b4fe'
                    : gachaAnimation.artifact.rarity === 'uncommon' ? '#93c5fd'
                    : '#d1d5db'
                }}>
                  {gachaAnimation.artifact.name}
                </h3>
                <p className="text-xl text-purple-200 mb-4">{gachaAnimation.artifact.description}</p>
                <div className="flex justify-center gap-6 text-lg">
                  <span className="text-red-400">ATK+{gachaAnimation.artifact.atk}</span>
                  <span className="text-blue-400">DEF+{gachaAnimation.artifact.def}</span>
                  <span className="text-purple-400">INT+{gachaAnimation.artifact.int}</span>
                </div>
              </div>
            )}
          </div>
        </div>
      )}

      {showLevelUp && (
        <div className="fixed inset-0 bg-black/90 flex items-center justify-center z-50">
          <div className="text-center animate-float">
            <div className="w-48 h-48 mx-auto mb-8 rounded-full bg-gradient-to-br from-yellow-400 via-orange-400 to-red-400 flex items-center justify-center animate-glow">
              <Crown className="w-32 h-32 text-white" />
            </div>
            <h2 className="text-5xl font-black text-yellow-200 mb-4">LEVEL UP!</h2>
            <p className="text-3xl text-purple-200 mb-2">
              Lv.{showLevelUp.oldLevel} → Lv.{showLevelUp.newLevel}
            </p>
            <p className="text-2xl text-yellow-300 mb-8">称号: {showLevelUp.newTitle}</p>
            <button
              onClick={() => setShowLevelUp(null)}
              className="px-8 py-4 bg-gradient-to-r from-purple-500 to-pink-500 hover:from-purple-600 hover:to-pink-600 text-white font-bold text-xl rounded-xl transition-all shadow-lg"
            >
              続ける
            </button>
          </div>
        </div>
      )}

      {notification && (
        <div className="fixed top-4 right-4 z-50 animate-float">
          <div className={`px-6 py-4 rounded-xl shadow-2xl border-2 ${
            notification.type === 'success'
              ? 'bg-green-500 border-green-300'
              : 'bg-red-500 border-red-300'
          }`}>
            <p className="text-white font-semibold">{notification.message}</p>
          </div>
        </div>
      )}
    </div>
  );
}
